import { TableComponent } from "./component";
export const Table = TableComponent;
